<template>
    <v-container>
        <v-row>
            <v-col>
                <h4 class="text-h4">Landed Cost Component</h4>
                <p class="text-subtitle-1">Adding a new landed cost component</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <LandedCostComponentForm
                    ref="form"
                    :name.sync="form.name"
                    :ledger-account-id.sync="form.ledger_account_id"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-btn color="primary" block @click="onSave" :loading="loading">
                    <v-icon left>mdi-content-save</v-icon>
                    save
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-btn depressed block @click="onCancel">
                    cancel
                </v-btn>
            </v-col>
        </v-row>
        <PAlert v-bind="alert" v-model="alert.display"/>
    </v-container>
</template>

<script>
import LandedCostComponentForm from '../../components/purchase/LandedCostComponentForm.vue';
import PAlert from '../../components/common/PAlert.vue';
import landedCostComponent from '../../services/purchase/landedCostComponent';
import { v4 as uuid } from 'uuid';
export default {
    components: {
        LandedCostComponentForm,
        PAlert
    },
    data() {
        return {
            form: {
                name: null,
                ledger_account_id: null
            },
            alert: {
                display: false,
                title: "Alert",
                content: "Are you sure?",
                callback: null
            },
            loading: false,
            idempotentKey: null
        }
    },
    methods: {
        onCancel() {
            this.alert = { ...this.alert, display: true, content: "Are you sure you want to discard changes?", callback: this.cancel };
        },
        cancel() {
            this.$router.back();
        },
        onSave() {
            this.alert = { ...this.alert, display: true, content: "Are you sure you want to save?", callback: this.save };
        },
        save() {
            if(!this.$refs.form.$refs.form.validate()) return;
            this.loading = true;
            landedCostComponent.store({...this.form, idempotentKey: this.idempotentKey}).then(res => {
                this.$router.replace({
                    name: "LandedCostComponentDisplay",
                    params: {
                        id: res.data.id
                    }
                })
            }).finally(() => {
                this.loading = false;
            })
        }
    },
    created() {
        this.idempotentKey = uuid();
    }
}
</script>

<style>

</style>